/**
 * @module interface
 */
import type { V2TIMMessageReaction } from './V2TIMMessageReaction';

export interface V2TIMMessageReactionResult {
    resultCode: number;
    resultInfo?: string;
    msgID?: string;
    reactionList?: V2TIMMessageReaction[];
}
